import { React, useState } from 'react'
import { View, Pressable, Text, Image, TouchableOpacity, Linking, ActivityIndicator } from "react-native"
import {logout} from "./../api/apiManager";
import AsyncStorageFunc from '../utilities/asyncStorage';
import RootNavigation from '../utilities/RootNavigation';
import { useLogin } from '../context/loginProvider';
import useStyles from './Header_Styles';

export default function Header (props)
{
        const styles = useStyles()
        const [loading, setLoading] = useState(false);
        const { isLoggedIn, setIsLoggedIn } = useLogin();
        const [showThisDropdown, setShowThisDropdown] = useState(["", "none"])

        const row1dropdown = [
                ['About Us', [
                        ['Our History', 'https://www.idfcfirstbank.com/about-us/our-history'],
                        ['MD & CEO Letter to Shareholders on the 1st Annual Report after Merger', 'https://www.idfcfirstbank.com/about-us/md-and-ceo-1st-letter-to-shareholders'],
                        ['MD & CEO Letter to Shareholders on the 2st Annual Report after Merger', 'https://www.idfcfirstbank.com/about-us/md-and-ceo-2nd-letter-to-shareholders'],
                        ['Board of Directors', 'https://www.idfcfirstbank.com/about-us/board-of-directors'],
                        ['Awards & Accolades', 'https://www.idfcfirstbank.com/about-us/awards-and-accolades'],
                        ['News Room', 'https://www.idfcfirstbank.com/about-us/news-and-media']
                ]],
                ['Investors', [
                        ['Investor Presentation (Q1-FY23)', 'https://www.idfcfirstbank.com/content/dam/idfcfirstbank/pdf/financial-results/IDFC-FIRST-Bank-Investor-Presentation-Q1-FY23.pdf'],
                        ['Annual Report (FY 2021-22)', 'https://www.idfcfirstbank.com/content/dam/idfcfirstbank/pdf/annual-report/Annual-Report-FY-2021-22.pdf'],
                        ['View All Annual Reports', 'https://www.idfcfirstbank.com/investors/annual-report'],
                        ['Financial Documents', 'https://www.idfcfirstbank.com/investors/financial-report'],
                        ['IDFC FIRST Infrastructure Bonds', 'https://www.idfcfirstbank.com/investors/ifb-infra-bonds-equity-shares'],
                        ['Other Investor Information', 'https://www.idfcfirstbank.com/investors']
                ]],
                ['Careers', [
                        ['Come work with us', 'https://careers.idfcfirstbank.com/in/en'],
                        ['Track job application', 'https://ekjx.fa.em2.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_1/my-profile/sign-in']
                ]],
                ['CSR', [
                        ['CSR Activities', 'https://www.idfcfirstbank.com/csr-activities'],
                        ['IDFC FIRST Sustainability', 'https://www.idfcfirstbank.com/scaling-up-sustainability-effort']
                ]],
                ['Customer Service', [
                        ['Requests/Complaints', 'https://www.idfcfirstbank.com/customer-care-sr'],
                        ['Compliments', 'https://www.idfcfirstbank.com/content/IDFCFirstBank/en/compliment.html'],
                        ['Contact Us', 'https://www.idfcfirstbank.com/customer-care'],
                        ['Visit Us', 'https://www.idfcfirstbank.com/support/branches']
                ]]
        ]

        const row2Dropdown = [
                ['SME Accounts', [
                        ['Freedom Current Account', 'https://www.idfcfirstbank.com/business-banking/accounts/freedom-current-account'],
                        ['World Business Account', 'https://www.idfcfirstbank.com/business-banking/accounts/world-business-account'],
                        ['Agri Multiplier Account', 'https://www.idfcfirstbank.com/business-banking/accounts/agri-multiplier-account'],
                        ['Merchant Multiplier Account', 'https://www.idfcfirstbank.com/business-banking/accounts/merchant-multiplier-account'],
                        ['Startup Current Account', 'https://www.idfcfirstbank.com/business-banking/accounts/startup-current-account'],
                        ['TASC Institutional Account', 'https://www.idfcfirstbank.com/business-banking/accounts/tasc-institutional-accounts']
                ]],
                ['SME Loans', [
                        ['Unsecured - Business Loan', 'https://www.idfcfirstbank.com/business-banking/loans/business-loan'],
                        ['Unsecured - Professional Loan', 'https://www.idfcfirstbank.com/business-banking/loans/professional-loans'],
                        ['Secured - Loan Against Property', 'https://www.idfcfirstbank.com/business-banking/loans/loan-against-property'],
                        ['Working Capital Loan', 'https://www.idfcfirstbank.com/business-banking/loans/working-capital-loan']
                ]],
                ['Business Solutions', [
                        ['POS Terminal', 'https://www.idfcfirstbank.com/business-banking/point-of-sale'],
                        ['UPI QR Code', 'https://www.idfcfirstbank.com/wholesale-banking/cms/collections/electronic-collections#nach'],
                        ['Virtual Account', 'https://www.idfcfirstbank.com/wholesale-banking/cms/collections/electronic-collections#rtgs'],
                        ['Payment Gateway', 'https://www.idfcfirstbank.com/business-banking/point-of-sale/internet-payment#merchant'],
                        ['NACH - Debit', 'https://www.idfcfirstbank.com/wholesale-banking/cms/collections/electronic-collections#imps'],
                        ['Escrow/Nodal Solutions', 'https://www.idfcfirstbank.com/wholesale-banking/cms/escrow'],
                        ['Host-to-Host/API Integrations', 'https://www.idfcfirstbank.com/wholesale-banking/cms/channels/api-host'],
                        ['Cash Delivery', 'https://www.idfcfirstbank.com/wholesale-banking/cms/payments/physical-payments#cash'],
                        ['Doorstep Banking - Cheque Collections', 'https://www.idfcfirstbank.com/business-banking/retail-solutions#cheque'],
                        ['Doorstep Banking - Cash Collections', 'https://www.idfcfirstbank.com/business-banking/retail-solutions#cash'],
                        ['Bulk Payments - Net Banking', 'https://www.idfcfirstbank.com/business-banking/retail-solutions#bulk']
                ]],
                ['Offers', [
                        ['Beyond Banking Offers', 'https://www.idfcfirstbank.com/business-banking/beyond-banking-offers'],
                        ['Debit Card Offers by VISA', 'https://www.idfcfirstbank.com/business-banking/debit-card-visa-offers'],
                        ['Local Offers', 'https://www.idfcfirstbank.com/offers/local-offers']
                ]]
        ]

        const handleClick = dropdownTitle => {
                setShowThisDropdown(prev =>
                        prev[0] === dropdownTitle ? ["", "none"] : [dropdownTitle, "#000"]
                )
        }

        const handleURLClick = url => {
                setShowThisDropdown("")
                Linking.openURL(url)
                .catch (err => console.log(err))
        }

        const userLogout = params => {
                setLoading(true)
                let req = {
                    userId: global.userId
                }
                logout(req).then((res) => {
                    setTimeout(() => {
                        setLoading(false)
                        AsyncStorageFunc.deleteData('TOKEN').then((tokenRes) => {
                            console.log(tokenRes, 'tokenRes3')
                            setIsLoggedIn(false)
                            RootNavigation.navigate("Login")
                        });
                    }, 1000);
        
                }).catch()
            }

        function handleSliderPress (page) {
                var url = ""
                switch (page) {
                        case 2: url = "https://www.idfcfirstbank.com/credit-card"
                                break
                        case 3: url = "https://www.idfcfirstbank.com/business-banking"
                                break
                        case 4: url = "https://www.idfcfirstbank.com/wholesale-banking"
                                break
                        case 5: url = "https://www.idfcfirstbank.com/nri-banking"
                                break
                }
                Linking.openURL(url)
                .catch (err => console.log(err))
        }

        return (
        <View style = {styles.Header_container}>
                <View style = {styles.Header_row1}>
                        <View style = {styles.Header_row1col1}>
                                <Image source = {require("../assets/images/IDFC_logo_2.png")} style = {styles.Header_IDFCLogo}/>
                                <View style = {styles.Header_slider}>
                                        <View style = {[styles.Header_sliderOption, styles.Header_sliderOptionActive]}><Text style = {styles.Header_sliderOptionText}>Personal</Text></View>
                                        <Pressable onPress = {()=>handleSliderPress(2)} style = {styles.Header_sliderOption}><Text style = {styles.Header_sliderOptionText}>Credit Card</Text></Pressable>
                                        <Pressable onPress = {()=>handleSliderPress(3)} style = {styles.Header_sliderOption}><Text style = {styles.Header_sliderOptionText}>Business</Text></Pressable>
                                        <Pressable onPress = {()=>handleSliderPress(4)} style = {styles.Header_sliderOption}><Text style = {styles.Header_sliderOptionText}>Wholesale</Text></Pressable>
                                        <Pressable onPress = {()=>handleSliderPress(5)} style = {styles.Header_sliderOption}><Text style = {styles.Header_sliderOptionText}>NRI</Text></Pressable>
                                </View>
                        </View>

                        <View style = {styles.Header_row1col2}>
                                {row1dropdown.map((dropdown, index) => {
                                        return (
                                        <View style = {styles.Header_dropdownContainer} key = {index}>
                                                <Pressable
                                                        style = {
                                                                dropdown[0] === showThisDropdown[0] ?
                                                                        [styles.Header_row1Dropdown, {backgroundColor : "#000"}]
                                                                        :
                                                                        [styles.Header_row1Dropdown, {backgroundColor : "none"}]
                                                        }
                                                        onPress = {()=>handleClick(dropdown[0])}
                                                >
                                                        <View style = {styles.Header_row1DropdownLabel}><Text style = {styles.Header_row1DropdownLabelText}>{dropdown[0]}</Text></View>
                                                        <Image
                                                                source = {dropdown[0] === showThisDropdown[0] ?
                                                                        require("../assets/images/red_uparrow.png")
                                                                        :
                                                                        require('../assets/images/red_downarrow.png')
                                                                }
                                                                style = {styles.Header_row1DropdownArrow}
                                                        />
                                                </Pressable>

                                                {dropdown[0] === showThisDropdown[0] ?
                                                <View style = {styles.Header_row1DropdownBody}>
                                                        {dropdown[1].map(option => {
                                                                return (
                                                                <View key={option} style = {styles.Header_row1DropdownBodyItem}>
                                                                        <Pressable
                                                                                style = {styles.Header_row1DropdownBodyItemTextContainer}
                                                                                onPress = {() => {handleClick(dropdown[0]); handleURLClick(option[1]);}}
                                                                        >
                                                                                <Text style = {styles.Header_row1DropdownBodyItemText}>{option[0]}</Text>
                                                                        </Pressable>

                                                                        <View style = {styles.Header_row1DropdownBodyItemImageContainer}>
                                                                                <Image
                                                                                        source = {require("../assets/images/blackbg_rightarrow.png")}
                                                                                        style = {styles.Header_row1DropdownBodyItemImage}
                                                                                />
                                                                        </View>
                                                                </View>)
                                                        })}
                                                </View>
                                                :
                                                null
                                                }
                                        </View>)
                                })}
                                <TouchableOpacity onPress={props?.text =="Login" ? ()=>RootNavigation.navigate('Login'): userLogout} style = {styles.Header_loginButton}><Text style = {styles.Header_loginButtonText}>{props?.text ? props?.text :"Logout"}</Text></TouchableOpacity>
                        </View>
                        {loading && <ActivityIndicator size={"large"} color="#707070" style={styles.spinner} />}
                </View>

                <View style = {styles.Header_row2}>
                        <View style = {styles.Header_row2col1}>
                                <View style = {[styles.Header_dropdownContainer, {marginRight: 20}]}>
                                        <Pressable style = {styles.row1dropdown} onPress = {()=>handleURLClick("https://www.idfcfirstbank.com/startup-banking")}>
                                                <View style = {styles.Header_row1DropdownLabel}>
                                                        <Text style = {styles.Header_row2DropdownLabelText}>Startup</Text>
                                                </View>
                                        </Pressable>
                                </View>
                                <View style = {[styles.Header_dropdownContainer, {marginRight: 10}]}>
                                        <Pressable style = {styles.row1dropdown} onPress = {()=>handleURLClick("https://www.idfcfirstbank.com/business-banking/debit-card")}>
                                                <View style = {styles.Header_row1DropdownLabel}>
                                                        <Text style = {styles.Header_row2DropdownLabelText}>Debit Card</Text>
                                                </View>
                                        </Pressable>
                                </View>
                                {row2Dropdown.map((dropdown, index) => {
                                        return (
                                        <View style = {styles.Header_dropdownContainer} key = {index}>
                                                <Pressable
                                                        style = {
                                                                dropdown[0] === showThisDropdown[0] ?
                                                                        [
                                                                                styles.Header_row1Dropdown,
                                                                                {backgroundColor : "#F6F6F6"},
                                                                                {borderBottomWidth: 3},
                                                                                {borderBottomColor: '#9c1d28'},
                                                                                {paddingTop: 3}
                                                                        ]
                                                                        :
                                                                        [styles.Header_row1Dropdown, {backgroundColor : "none"}]
                                                        }
                                                        onPress = {()=>handleClick(dropdown[0])}
                                                >
                                                        <View style = {styles.Header_row1DropdownLabel}><Text style = {styles.Header_row2DropdownLabelText}>{dropdown[0]}</Text></View>
                                                        <Image
                                                                source = {dropdown[0] === showThisDropdown[0] ?
                                                                        require("../assets/images/red_uparrow.png")
                                                                        :
                                                                        require('../assets/images/red_downarrow.png')
                                                                }
                                                                style = {styles.Header_row1DropdownArrow}
                                                        />
                                                </Pressable>

                                                {dropdown[0] === showThisDropdown[0] ?
                                                <View style = {styles.Header_row2DropdownBody}>
                                                        <View style = {styles.Header_row2DropdownBodyHeading}>
                                                                <Text style = {styles.Header_row2DropdownBodyHeadingTitle}>IDFC FIRST BANK {dropdown[0]}</Text>
                                                                {dropdown[0] === "SME Accounts" || dropdown[0] === "SME Loans" ?
                                                                        <Pressable style = {styles.Header_row2DropdownBodyHeadingLinkContainer} onPress={()=>{
                                                                                if(dropdown[0] === "SME Accounts") handleURLClick("https://www.idfcfirstbank.com/business-banking/accounts")
                                                                                else if(dropdown[0] === "SME Loans") handleURLClick("https://www.idfcfirstbank.com/business-banking/loans")
                                                                        }}>
                                                                                <Text style = {styles.Header_row2DropdownBodyHeadingLink}>View All {dropdown[0]}</Text>
                                                                                <Image
                                                                                        source = {require("../assets/images/whitebg_rightarrow.png")}
                                                                                        style = {styles.Header_row1DropdownBodyItemImage}
                                                                                />
                                                                        </Pressable>
                                                                        : null
                                                                }
                                                        </View>
                                                        {dropdown[1].map(option => {
                                                                return (
                                                                <View key={option} style = {styles.Header_row2DropdownBodyItem}>
                                                                        <Pressable
                                                                                style = {styles.Header_row2DropdownBodyItemTextContainer}
                                                                                onPress = {() => {handleClick(dropdown[0]); handleURLClick(option[1]);}}
                                                                        >
                                                                                <Text style = {styles.Header_row2DropdownBodyItemText}>{option[0]}</Text>
                                                                        </Pressable>

                                                                        <View style = {styles.Header_row2DropdownBodyItemImageContainer}>
                                                                                <Image
                                                                                        source={require("../assets/images/red_downarrow.png")}
                                                                                        style = {styles.Header_row2DropdownBodyItemImage}
                                                                                />
                                                                        </View>
                                                                </View>)
                                                        })}
                                                </View>
                                                :
                                                null
                                                }
                                        </View>)
                                        })}
                                </View>

                        <View style = {styles.Header_row2col2}>
                                <Image source = {require("../assets/images/red_phone.png")} style = {styles.Header_row2Phoneicon}/>

                                <View style = {styles.Header_row2Phonelabel}>
                                        <View style = {styles.Header_row2PhonelabelLine1}><Text>Need a new product?</Text></View>
                                        <View style = {styles.Header_row2PhonelabelLine2}><Text>1800 10 888</Text></View>
                                </View>

                                <Image source = {require("../assets/images/notification_bell.png")} style = {styles.Header_bellIcon}/>
                        </View>
                </View>
        </View>
        )
}

